<div class="wrapper">
    <div class="m-box">
        <h2>Patient details </h2>
        <div style="display: flex;flex-direction: row;">
        <div class="w50 warp">
            <div class="w50"><label class="label">First Name: </label><span>{{patientService.currentPatient.First}}</span></div>
            <div class="w50"><label class="label">Last Name: </label><span>{{patientService.currentPatient.Last}}</span></div>
            <div class="w50"> <label class="label">ID: </label><span>{{patientService.currentPatient.ID}}</span></div>
            <div class="w50"> <label class="label">Mobile: </label><span>{{patientService.currentPatient.Mobile}}</span></div>
            <div class="w50"><label class="label">Birth: </label><span>{{patientService.currentPatient.Birth}}</span> </div>
            <div class="w50"><label class="label">Age: </label><span>{{patientService.getAgeMo()}}</span> </div>
            <div class="w50"> <label class="label">Email: </label><span>{{patientService.currentPatient.Email}}</span> </div>
            <div class="w50"> <label class="label">HMO: </label><span>{{patientService.currentPatient.HMO}}</span> </div>
            <div class="w50" *ngIf="this.ls.isObgyn"> <label class="label">Lmp: </label><span>{{patientService.currentPatient.LMP  | date:"dd.MM.yyyy"}}</span> </div>
        </div>
        <div>
            <button  class="orange-btn" (click)="editPat=true">Edit Patient</button> 
        </div>
     </div>
     <div>
     
        <div  class="search-results">
        <table *ngIf="appointments.length">
            <thead>
              <tr>
                <th>#</th>
                <th>Appointment</th>
                <th>Date</th>
                <th>Time</th>
                <th>Doctor</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let appointment of appointments| sortByDateTime; let i = index">
                <td>{{i + 1}} </td>
                <td>{{ appointment.examName }}</td>
                <td>{{ appointment.aptTime | date:"dd.MM.yyyy"}}</td>
                <td>{{ appointment.aptTime | date:"HH:mm" }}-{{ appointment.aptEndTime | date:"HH:mm" }} ({{appointment.aptlength}} min)  </td>
                <td>{{ appointment.docName }}</td>
                <td><button  class="blue-btn fit-height" (click)="editAppointment(appointment)" >Edit Appointment</button> </td>
                <td> <button *ngIf="isToday(appointment.aptTime)" class="blue-btn fit-height" (click)="updateArrival(appointment.AutoIndex,appointment.Arrived? false: true)">{{appointment.Arrived? 'Cancel Arrival':'Patient Arrival'}}</button> </td>
              </tr>
            </tbody>
          </table>
     </div>
     <div>
        <button  class="blue-btn" (click)="showPrevious=!showPrevious">Previous Appointments </button> 
        <button  class="blue-btn" (click)="setPage('Calendar')" >Schedule New Appointment </button> 
    </div>
    <div  *ngIf="showPrevious">
        <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Appointment</th>
                <th>Date</th>
                <th>Time</th>
                <th>Doctor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let appointment of preAppointments | sortByDateTime; let i = index">
                <td>{{i + 1}} </td>
                <td>{{ appointment.examName }}</td>
                <td>{{ appointment.aptTime | date:"dd.MM.yyyy"}}</td>
                <td>{{ appointment.aptTime | date:"HH:mm" }}-{{ appointment.aptEndTime | date:"HH:mm" }} ({{appointment.aptlength}} min)  </td>
                <td>{{ appointment.docName }}</td>
              </tr>
            </tbody>
          </table>
     </div>
    </div>
    </div>
</div>
<app-patdetails *ngIf="editPat" (closed)="editPat=false" [page]="'Patients'"></app-patdetails>
<app-appointment *ngIf="showAppointment" [event]="selectedEventInfo" (closed)="closeAppointment()"></app-appointment>